var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMismatchedData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5769 4.76282L13.8995 1.15106C13.8009 1.05425 13.6683 1 13.53 1H4.23294C3.14804 1 2.26529 1.88261 2.26529 2.96765V17.0323C2.26529 18.1172 3.1479 19 4.23294 19H15.7671C16.852 19 17.7347 18.1174 17.7347 17.0323V5.1391C17.7347 4.99751 17.6779 4.86197 17.5769 4.76282ZM14.0573 2.78445L15.9179 4.61176H14.225C14.1326 4.61176 14.0573 4.5365 14.0573 4.44408V2.78445ZM15.7671 17.9453H4.23294C3.72963 17.9453 3.31998 17.5358 3.31998 17.0323V2.96765C3.31998 2.4642 3.72949 2.05469 4.23294 2.05469H13.0028V4.44408C13.0028 5.11809 13.5511 5.66644 14.2251 5.66644H16.68V17.0323C16.68 17.5358 16.2705 17.9453 15.7671 17.9453Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5027 10H6.49666C6.22215 10 5.99966 10.2238 5.99966 10.5C5.99966 10.7762 6.22215 11 6.49666 11H13.5027C13.7772 11 13.9997 10.7762 13.9997 10.5C13.9997 10.2238 13.7772 10 13.5027 10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59251 13H13.4068C13.7343 13 13.9997 12.7762 13.9997 12.5C13.9997 12.2238 13.7343 12 13.4068 12H6.59251C6.26505 12 5.99966 12.2238 5.99966 12.5C5.99966 12.7762 6.26505 13 6.59251 13Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8834 8.39282L7.3515 13.4527C7.15716 13.6697 7.17551 14.003 7.39248 14.1974C7.60945 14.3917 7.9428 14.3733 8.13713 14.1564L12.6691 9.09648C12.8633 8.87961 12.8451 8.54616 12.6281 8.35183C12.4111 8.1575 12.0777 8.17595 11.8834 8.39282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMismatchedData);
export default __webpack_public_path__ + "static/media/MismatchedData.0c83520df01b16484d2bb3eb6f2cfeff.svg";
export { ForwardRef as ReactComponent };